import { render, staticRenderFns } from "./BusStandardTeamConfigModal__Style#Drawer.vue?vue&type=template&id=48e2b583&scoped=true&"
import script from "./BusStandardTeamConfigModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./BusStandardTeamConfigModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./BusStandardTeamConfigModal__Style#Drawer.vue?vue&type=style&index=0&id=48e2b583&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e2b583",
  null
  
)

export default component.exports